/**
 * Full-page navigation to an external URL (e.g. a hosted payment page).
 * Kept as a separate module so it can be mocked in tests — JSDOM does not
 * allow stubbing window.location directly.
 */
export const redirectExternal = (url: string) => {
  window.location.assign(url);
};

/**
 * When the current document is embedded in an iframe (the Computop credit-card
 * modal renders the return page inside its iframe), navigates the *top* window
 * to the current URL and returns `true`. In the top window it does nothing and
 * returns `false`. Kept here so it can be mocked in tests — JSDOM does not allow
 * stubbing `window.top`.
 *
 * A *cross-origin* top window returns `false` as well: reading its `location` and
 * navigating it both raise a SecurityError, which would otherwise escape into the
 * caller's effect and take the return page down with it. That case is not the
 * Computop modal — our own page hosts it, so the top window is same-origin — but
 * on the page that finalizes a paid order, an embed we did not foresee must not
 * cost the customer their order confirmation. Reporting "did not break out" lets
 * the caller finalize inside this frame instead.
 */
export const breakOutOfIframe = (): boolean => {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.replace(window.location.href);
      return true;
    }
  } catch {
    return false;
  }
  return false;
};
